<template>
  <div class="page-content-wrapper" >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">
              <template v-check-permission="'manage-registration-to-careers'">
                <h5 class="mt-0 header-title card-title">Configuración para la inscripción a carreras</h5>
                <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>
                <div class="alert alert-success p-3" role="alert" v-if="savedSuccessfully">Los datos se han guardado.</div>
                <div class="row">
                  <div class="form-group col-md-4" v-bind:class="{ 'has-danger': $v.registrationToCareers.academicYear.$error }">
                    <label>Ciclo lectivo actual</label>
                    <input type="number" class="form-control" v-model="registrationToCareers.academicYear" @input="$v.registrationToCareers.academicYear.$touch()">
                    <div class="form-control-feedback" v-if="!$v.registrationToCareers.academicYear.required && $v.registrationToCareers.academicYear.$error">El ciclo lectivo es requerido.</div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 m-b-0">
                    <label>Activar la inscripción a las carreras</label>
                    <div>
                      <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" v-model="registrationToCareers.active">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Activo</span>
                      </label>
                    </div>
                    <small class="form-text text-muted">Activar esta opción para habilitar el formulario de inscripción de los alumnos a las carreras, y desactivarlo cuando se quiera deshabilitar dicho formulario.</small>
                  </div>
                </div>

                <div class="card-block pull-right pr-0">
                  <div class="loading waves-effect mr-2" v-if="isSaving">
                    <i class="fa fa-spin fa-circle-o-notch"></i>
                  </div>
                  <router-link to="/" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light" @click="submitRegistrationToCareers()">Guardar</a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'manage-registration-to-careers',


    created () {
      this.getAllConfigurations()
    },


    data () {
      return {
        error: '',
        isSaving: false,
        savedSuccessfully: false,
        registrationToCareers: {
          academicYear: null,
          active: false
        }
      }
    },


    computed: {
      configurations: function () {
        return this.$store.getters.getAllConfigurations
      }
    },


    validations: {
      registrationToCareers: {
        academicYear: { required }
      }
    },


    methods: {
      getAllConfigurations: function () {

        var self = this

        this.$store.dispatch('getAllConfigurations')
          .then((response) => {

            if (response.success) {
              if (this.$acl.checkPermission('manage-registration-to-careers')) {
                var configItem = self.getConfigByKey('registrationToCareers.academicYear')
                if(configItem)
                  self.registrationToCareers.academicYear = Number(configItem.value)

                var configItem = self.getConfigByKey('registrationToCareers.active')
                if(configItem)
                  self.registrationToCareers.active = Boolean(configItem.value)
              }
            }

          })
          .catch((response) => {
            this.error = response.message
          })

      },

      getConfigByKey: function (key) {
        return this.configurations.filter( (item) => {
          if(item.key === key) {
            return item
          }
        })[0]
      },

      getConfigValueByKey: function (key) {
        return this.configurations.filter( (item) => {
          if(item.key === key) {
            if(item.dataType === 'number') {
              return Number(item.value)
            } else if (item.dataType === 'boolean') {
              return Boolean(item.value)
            }
            return item.value
          }
        })[0]
      },

      submitRegistrationToCareers() {

        var self = this

        this.$v.registrationToCareers.$touch()

        if(!this.$v.registrationToCareers.$error) {

          this.isSaving = true
          this.savedSuccessfully = false

          //Guardamos el valor de configuracion del año academico actual
          this.$store.dispatch('editConfig', { config: { key: 'registrationToCareers.academicYear', value: self.registrationToCareers.academicYear, dataType: 'number' } })
            .then((response) => {
              self.isSaving = false
              self.savedSuccessfully = true

              setTimeout(function () {
                self.savedSuccessfully = false
              }, 500)
            })
            .catch((response) => {
              this.isSaving = false
              self.savedSuccessfully = false
              this.error = response.message
            })

          //Guardamos el valor de configuracion para activar el formulario de inscripcion a las carreras
          this.$store.dispatch('editConfig', { config: { key: 'registrationToCareers.active', value: self.registrationToCareers.active, dataType: 'boolean' } })
            .then((response) => {
              self.isSaving = false
              self.savedSuccessfully = true

              setTimeout(function () {
                self.savedSuccessfully = false
              }, 500)
            })
            .catch((response) => {
              this.isSaving = false
              self.savedSuccessfully = false
              this.error = response.message
            })

        }

      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/screens/ConfigScreen.vue